const { api } = require('@cashew/utils');

export const useGetOrderDetails = (
  orderId: string,
  setOrderDetails: any,
  setLoading: any,
  dispatch: any,
  t: any
) => {
  setLoading(true);
  api
    .get({
      endpoint: `orders/${orderId}`,
    })
    .then(async (resp: any) => {
      const hasCustomer = false;
      if (!hasCustomer) {
        await api
          .get({
            endpoint: `orders/${orderId}/customer`,
          })
          .then((customerResponse: any) => {
            // eslint-disable-next-line no-param-reassign
            resp.data.customer = customerResponse.data;
          })
          .catch((error: any) => {
            console.log(error);
          });
      }
      setOrderDetails(resp.data);
    })
    .catch(() =>
      dispatch({
        type: 'OPEN_TOASTER',
        payload: {
          toasterTitle: t('orderDetails.error.fetchDetails.title'),
          toasterMessage: t('orderDetails.error.fetchDetails.message'),
          toasterType: 'error',
          toasterVisible: true,
          toasterDismiss: null,
        },
      })
    )
    .finally(() => {
      setLoading(false);
    });
};
